import * as React from 'react';
import { SVGProps } from 'react';

const SvgCrossIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M18 6 6 18M6 6l12 12" stroke="#797979" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SvgCrossIcon;
